require('jquery-typeahead');

var s;
var SearchWidget = {
  settings: {
    input: '.js-typeahead-user_v1'
  },

  init: function() {
    s = this.settings;
    this.bindUIActions();
  },

  bindUIActions: function() {
    $.typeahead({
      input: s.input,
      minLength: 1,
      order: 'asc',
      dynamic: true,
      delay: 500,
      maxItem: 11,
      maxItemPerGroup: 5,
      filter: false,
      display: ['prod_name', 'cat_name', 'sub_name'],
      group: true,
      accent: false,
      emptyTemplate: 'No result for "{{query}}"',
      source: {
        Products: {
          display: 'prod_name',
          ajax: {
            url: '/api/search/suggestions',
            data: {
              query: '{{query}}'
            },
            path: 'results.products.rows'
          },
          template: function(query, item) {
            return (
              "<span class='suggestion-row'>" +
              '<a class="suggestion-result" href="/product/{{prod_id}}">{{prod_name}}</a>' +
              '</span>'
            );
          }
        },
        Categories: {
          display: 'cat_name',
          ajax: {
            url: '/api/search/suggestions',
            data: {
              query: ''
            },
            path: 'results.categories'
          },
          template: function(query, item) {
            return (
              '<span class="suggestion-row">' +
              '<a class="suggestion-result" href="/category/{{cat_id}}">{{cat_name}}</a>' +
              '</span>'
            );
          }
        },
        Suppliers: {
          display: 'sub_name',
          ajax: {
            url: '/api/search/suggestions',
            data: {
              query: ''
            },
            path: 'results.suppliers'
          },
          template: function(query, item) {
            console.log(item);
            return (
              '<span class="suggestion-row">' +
              '<a class="suggestion-result" href="/supplier/{{sub_id}}">{{sub_name}}</a>' +
              '</span>'
            );
          }
        }
      },

      callback: {
        onSendRequest: function(node, query) {
          console.log('request is sent');
        },
        onReceiveRequest: function(node, query) {
          console.log('request is received');
        }
      },
      debug: true
    });
  }
};

module.exports = SearchWidget;



// WEBPACK FOOTER //
// ./public/src/js/SearchSuggestions.js